import { SquareStackIcon } from '@/icons';
import { cn } from '@/utils';
type CopyCounterProps = {
  count: number;
  className?: string;
};
export const CopyCounter = ({
  count,
  className
}: CopyCounterProps) => {
  if (!count) return null;
  return <div className={cn('flex items-center gap-2xs text-neutral', className)} data-sentry-component="CopyCounter" data-sentry-source-file="CopyCounter.tsx">
      <SquareStackIcon size="xs" className="hidden tablet-sm:block" data-sentry-element="SquareStackIcon" data-sentry-source-file="CopyCounter.tsx" />
      <SquareStackIcon size="2xs" className="tablet-sm:hidden" data-sentry-element="SquareStackIcon" data-sentry-source-file="CopyCounter.tsx" />
      <span>{count.toLocaleString()}</span>
    </div>;
};